var _defs, _g, _tspan, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 36,
    viewBox: "0 0 84.667 9.525",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "translate(851.668 187.75) scale(328.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9A2589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#9A258A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#9A258A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#9B258A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#9B2589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#9B2589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#9C2589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#9C2589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#9D2589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#9D2589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#9D2589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#9E2589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#9E2689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#9E2689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#9E2688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9E2588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#9F2588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#9F2588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#9F2588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#A02587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A02587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#A02587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#A12587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#A12687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#A12687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#A22687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#A22687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#A32687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#A32687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#A42587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#A42586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#A42586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A52686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#A52687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A52686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#A62686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#A62686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#A62686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A72686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#A72686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#A72686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#A82686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#A82686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#A82686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#A92686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#A92686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#A92686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#AA2686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#AA2686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#AB2686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#AB2786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#AB2786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#AC2786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#AC2786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#AC2786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#AC2886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#AD2886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#AD2886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#AE2886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#AE2986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#AE2986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#AF2986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#AF2986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#B02A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#B12A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#B12B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#B12B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B12B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#B22C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#B22C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#B22C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B32C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#B42D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#B42D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#B42D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#B52D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#B52D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#B52E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#B62E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B62E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#B62E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#B72F86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#B72F86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#B72F86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#B82F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#B82F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#B83087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B93087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#B93187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#B93187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#BA3186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#BA3187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BA3287"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#BB3287"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#BB3287"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    stopColor: "#BC3387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#BC3387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#BC3387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#BD3387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#BD3387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#BD3487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#BD3487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#BE3487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#BE3487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#BF3587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#BF3587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#BF3587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C03586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#C03586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#C13486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#C13485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#C13485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#C23485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#C23485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#C33484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#C33484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#C33384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#C33383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#C33383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#C33383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#C33382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#C43382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#C43382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C53382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#C53281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#C63281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#C63281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C63280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#C63280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#C63280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#C73280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#C73280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#C7327F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#C8327F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#C8327F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#C8327F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#C9317E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#C9317E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#C9317D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#CA317D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#CA317D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#CA317D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#CA317D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#CB317D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CB317C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#CB317C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#CB317C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#CB307B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#CC307B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CC307B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#CC307B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#CD307B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#CD307B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#CD307A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#CD317A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#CE317A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#CE307A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#CE307A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#CE3079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#CE3079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#CF3079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D03079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#D03079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#D03079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#D03078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D13078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#D13078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#D13078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D13078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#D23078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#D23078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#D23077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#D33077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#D33077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#D33077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#D43076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#D43176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D43176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#D43176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#D43176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#D53176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#D53176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#D53176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#D63176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#D63176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#D63175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#D63175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#D63175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#D73175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#D73175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#D73175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#D73175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#D73175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#D83175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D83274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#D93274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#D93274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#D93274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#D93274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#D93274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#DA3274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#DA3274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#DA3273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#DA3274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#DB3373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#DB3373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#DB3373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#DB3373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#DC3373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#DC3373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#DC3372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#DC3372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC3372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD3372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    x1: 5.977,
    y1: 19.324,
    x2: 37.994,
    y2: -5.65,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.33084 0 0 .33084 .088 -.001)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1169.52 159.578H862.129c-5.777 0-10.461 4.692-10.461 10.461v35.41c0 5.781 4.684 10.461 10.46 10.461h307.391c5.77 0 10.461-4.68 10.461-10.46v-35.41c0-5.77-4.69-10.462-10.46-10.462zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1169.52 159.578H862.129c-5.777 0-10.461 4.692-10.461 10.461v35.41c0 5.781 4.684 10.461 10.46 10.461h307.391c5.77 0 10.461-4.68 10.461-10.46v-35.41c0-5.77-4.69-10.462-10.46-10.462"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(.26458 0 0 .26458 -471.634 -367.855)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M851.668 159.578v56.332h328.312v-56.332zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#006978"
  }, /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25,
      InkscapeFontSpecification: "'Tahoma, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    },
    x: 9.98,
    y: 7.324,
    fontWeight: 700,
    fontSize: 7.056,
    fontFamily: "Tahoma",
    strokeWidth: 0.61,
    transform: "translate(-.13 -.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      InkscapeFontSpecification: "'Tahoma, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    },
    x: 9.98,
    y: 7.324
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    fill: "#f60"
  }, "SURFAUX")), " DYE CHEM")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.208 7.614l-1.644-.949v-.19l.001-.191.819-.434c.45-.238.838-.433.862-.432.023.001.384.187.802.414.417.226.774.41.793.41.061 0 .976-.499.967-.527-.005-.015-.66-.42-1.456-.902L2.905 3.94l-.007-.169-.008-.168.966-.553c.531-.305.98-.553.998-.553.018 0 .378.205.801.456l.769.457.36-.187c.198-.103.351-.196.34-.207a51.933 51.933 0 00-1.036-.607l-1.125-.65-.109-.064-1.327.766-1.326.766-.014.97-.014.97-.295.16c-.163.087-.3.158-.305.158-.005 0-.006-.592-.003-1.316l.007-1.315 1.638-.946L4.852.96l.083.049 1.647.95 1.565.904v.367l-.305.162c-.168.089-.562.29-.878.449l-.572.288-.755-.45c-.415-.249-.768-.452-.783-.452-.04-.001-.96.524-.96.548 0 .01.655.414 1.456.897l1.456.88v.375l-.971.523c-.534.288-.98.523-.99.523-.011 0-.369-.189-.795-.42-.426-.23-.79-.42-.808-.42-.055 0-.676.337-.668.362.015.046 2.254 1.321 2.299 1.31.024-.007.488-.268 1.03-.581.541-.313 1.12-.647 1.288-.742l.304-.172.001-.976.001-.975.325-.17.325-.171v2.644l-1.104.636-1.647.95-.544.315-1.644-.95z",
    stroke: "url(#e)",
    strokeWidth: 0.02,
    strokeMiterlimit: 0,
    paintOrder: "markers stroke fill",
    transform: "translate(-.13 -.13)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93d6d61f5f133e5deda542f05f1f2210.svg";
export { ForwardRef as ReactComponent };